/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './recipe-tags.reducer';

export const RecipeTagsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const recipeTagsEntity = useAppSelector(state => state.recipeTags.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="recipeTagsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.recipeTags.detail.title">RecipeTags</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{recipeTagsEntity.id}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.recipeTags.tag">Tag</Translate>
          </dt>
          <dd>{recipeTagsEntity.tag ? recipeTagsEntity.tag.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.recipeTags.recipe">Recipe</Translate>
          </dt>
          <dd>{recipeTagsEntity.recipe ? recipeTagsEntity.recipe.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/recipe-tags" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/recipe-tags/${recipeTagsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default RecipeTagsDetail;
